

































































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import CollectionItemStore, {
  CollectionItemStoreInterface,
} from '@/resource/collection-item/collection-item.store';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import { CollectionItem } from '@/resource/collection-item/collection-item.model';

@Component({
  components: {
    MainButton,
    BeatLoader,
    QuestionContainer,
  },
})
export default class CourseItemExercise extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Prop({ required: true })
  collectionUuid: string;

  collectionItemStore: CollectionItemStoreInterface = CollectionItemStore;

  isLoading = true;

  currentQuestionIndex = 0;

  collectionItems: CollectionItem[] = [];

  selectedAnswer: number | null = null;

  isFinished = false;

  get collectionItem(): CollectionItem {
    return this.collectionItems[this.currentQuestionIndex];
  }

  get question() {
    return this.collectionItem && this.collectionItem.questionObjective;
  }

  get lastObjectiveQuestion() {
    return this.collectionItemStore.lastObjectiveQuestion;
  }

  async mounted() {
    this.isLoading = true;

    this.collectionItems = [];

    if (this.collectionUuid) {
      this.collectionItemStore.pagination.page = 2;
      this.collectionItemStore.pagination.limit = 1;
      this.collectionItemStore.pagination.isResetPage = true;
      await this.collectionItemStore.fetchCollectionItems(this.collectionUuid);
      this.collectionItems.push(this.collectionItemStore.collectionItems[0]);
    }

    this.isLoading = false;
  }

  async nextQuestion() {
    this.isLoading = true;

    this.collectionItems[
      this.currentQuestionIndex
    ].selectedAnswer = this.selectedAnswer;

    if (
      !this.collectionItems[this.currentQuestionIndex + 1] &&
      this.collectionUuid
    ) {
      // to update pagination before request API
      this.collectionItemStore.pagination.page++;
      this.collectionItemStore.pagination.isResetPage = true;

      await this.collectionItemStore.fetchCollectionItems(this.collectionUuid);
      this.collectionItems.push(this.collectionItemStore.collectionItems[0]);
    }

    this.currentQuestionIndex++;
    this.selectedAnswer = this.collectionItems[
      this.currentQuestionIndex
    ].selectedAnswer;

    this.isLoading = false;
  }

  prevQuestion() {
    this.currentQuestionIndex--;
    this.selectedAnswer = this.collectionItems[
      this.currentQuestionIndex
    ].selectedAnswer;
  }

  selectedAnswerAdd(selectedAnswer: number) {
    this.selectedAnswer = selectedAnswer;
  }

  finishExercise() {
    this.collectionItems[
      this.currentQuestionIndex
    ].selectedAnswer = this.selectedAnswer;

    const result = this.collectionItems.map(item => {
      return item.answerPosition === item.selectedAnswer ? true : false;
    });

    const correctAnswer = result.filter(Boolean).length;

    const score = correctAnswer / result.length;
    this.isFinished = true;

    if (score > 0.8) {
      alert(`Tahniah! Score anda ${score * 100}%`);
    } else {
      alert(`Cuba lagi, score anda ${score * 100}%`);
    }
  }

  refreshPage() {
    window.location.reload();
  }
}
